module.exports = __webpack_public_path__ + "static/media/LifeDlogo.aa0b871b.png";